import { apiRequest } from "../utils/http.js";


export async function getTransportGroupsByDate(dateStr) {
  return (await apiRequest(`api/transport/groups?date=${dateStr}`)) || [];
}
